/**
=========================================================
* CarbonAGX Website - v2.0.0
=========================================================
* 
* Copyright 2022 CarbonAGX
=========================================================
* 
*/

import React from "react";
import ReactDOM from "react-dom";

import App from "App";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";

ReactDOM.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
    </ThemeProvider>,
    document.getElementById("root")
);
